import Vue from 'vue'
import httpManager from "../../util/common";
import XEUtils from "xe-utils";
Vue.config.productionTip = false

let vm = {
  delimiters: ['{', '}'],
  name: 'entity-title',
  props: {
    oaid: String
  },
   data: () => {
    return {
      entity_info: {
        entname: null,
        followed: false,
        entname_en: null,
        ticker: null,
        bond: null,
        delisting_date: null,
        esdate: null,
        website: null,
        incorporated_country: null,
        dom_country: null,
        industry: null,
      },
    }
  },
  methods: {
    isFollow(){
      let self = this
      let params = new Map()
      params.set('oaid', self.oaid)
      httpManager('is_follow_entity', params)
        .then(response => {
          self.entity_info['followed'] = response.data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    changeFollow(){
      let urlStr = "unfollow_entity"
      if(!this.entity_info.followed){
        urlStr = "follow_entity"
      }
      let self = this
      let params = new Map()
      params.set('oaid', self.oaid)
      httpManager(urlStr, params)
        .then(response => {
          if (response.data.msg === '超过允许关注最大数量') {
            return this.$message.warning(this.$t('tips.follow_entity_overmax'))
          }
          self.isFollow()
        })
        .catch(error => {
          console.log(error)
        })
    },
    getEntityBasicInfo () {
      let self = this
      let params = new Map()
      params.set('oaid', self.oaid)
      httpManager('entity_basic_info', params)
        .then(response => {
          self.entity_info['entname_en'] = response.data.data['entname_en']
          self.entity_info['ticker'] = response.data.data['ticker']
          self.entity_info['bond'] = response.data.data['bond']
          self.entity_info['esdate'] = response.data.data['esdate']
          self.entity_info['website'] = response.data.data['website']
          self.entity_info['incorporated_country'] = self.$t('country.' + response.data.data['incorporated_country'])
          self.entity_info['dom_country'] = self.$t('country.' + response.data.data['dom_country'])
          self.entity_info['industry'] = response.data.data['industryconame']
          self.entity_info['entname'] = response.data.data['entname']
          let delisted_date = response.data.data['delisted_date']
          for(let date in delisted_date){
            if(delisted_date[date]){

              self.entity_info['delisted_date'] = delisted_date[date].date + '（' + delisted_date[date].ticker +'）'
              break
            }

          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  mounted () {
    this.getEntityBasicInfo()
    this.isFollow()
  }
}
Vue.component("entity-title", vm)
export default vm



// WEBPACK FOOTER //
// ./src/entity/js/entity_title.js